module.exports = __webpack_public_path__ + "static/media/001-emoji.1241b82b.svg";